import { useCallback, useState } from "react";

import __ from "web/Layout/Translations";

import Button from "web/Components/Common/Button";
import defaultButtonClasses from "web/Components/Common/Button/button.scss";
import WcagTooltipWrapper from "web/Components/Common/ToolTip/wcagTooltipWrapper";

import tooltipMessages from "web/constants/tooltipMessages";

import classes from "./unavailableTooltip.scss";

let timeout: NodeJS.Timeout;

export const enum UnavailableTooltipVariants {
  OOS = "OOS",
  NA = "na",
}

interface UnavailableTooltipProps {
  variant?: UnavailableTooltipVariants;
  isWCAG?: boolean;
}

const UnavailableTooltip = ({
  variant = UnavailableTooltipVariants.OOS,
  isWCAG = false,
}: UnavailableTooltipProps) => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  const handleTouch = useCallback(() => {
    if (timeout) {
      clearTimeout(timeout);
    }

    setIsTooltipVisible(true);
    timeout = setTimeout(() => {
      setIsTooltipVisible(false);
    }, 5000);
  }, []);

  const buttonLabel =
    variant === UnavailableTooltipVariants.OOS
      ? __("Chwilowo wyprzedane")
      : __("Produkt niedostępny");

  const tooltipMessage = __(tooltipMessages.productUnavailable);
  const tooltipId = `unavailable-tooltip-${variant}`;

  const wcagTriggerAppearanceClassName = [
    defaultButtonClasses.root,
    defaultButtonClasses.root_primary,
    defaultButtonClasses.root_medium,
    defaultButtonClasses.root_block,
    defaultButtonClasses.root_disabled,
  ].join(" ");

  if (isWCAG) {
    return (
      <div className={classes.root}>
        <WcagTooltipWrapper
          touchAutoHideMs={5000}
          renderTrigger={({
            isOpen: _isOpen,
            onTouchStart,
            onMouseEnter,
            onMouseLeave,
            ...buttonProps
          }) => (
            <div
              className={classes.tooltip}
              onMouseEnter={onMouseEnter}
              onMouseLeave={onMouseLeave}
            >
              <button
                type="button"
                {...buttonProps}
                className={wcagTriggerAppearanceClassName}
                aria-disabled="true"
                aria-label={buttonLabel}
                aria-describedby={tooltipId}
                onTouchStart={() => {
                  onTouchStart();
                  handleTouch();
                }}
              >
                {buttonLabel}
              </button>
            </div>
          )}
          renderTooltip={(isOpen) => (
            <div
              id={tooltipId}
              role="tooltip"
              className={`${classes.messageFromRight} ${
                isOpen ? classes.visible : ""
              }`}
            >
              <span>{tooltipMessage}</span>
            </div>
          )}
        />
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <div
        className={classes.tooltip}
        onMouseEnter={() => setIsTooltipVisible(true)}
        onMouseLeave={() => setIsTooltipVisible(false)}
        onTouchStart={handleTouch}
      >
        <Button disabled>{buttonLabel}</Button>
        <div
          className={`${classes.messageFromRight} ${
            isTooltipVisible ? classes.visible : ""
          }`}
          role="tooltip"
        >
          <span>{tooltipMessage}</span>
        </div>
      </div>
    </div>
  );
};

export default UnavailableTooltip;
